import { render, staticRenderFns } from "./TaxcardSummary.vue?vue&type=template&id=99ec760a&scoped=true&"
import script from "./TaxcardSummary.vue?vue&type=script&lang=ts&"
export * from "./TaxcardSummary.vue?vue&type=script&lang=ts&"
import style0 from "./TaxcardSummary.vue?vue&type=style&index=0&id=99ec760a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ec760a",
  null
  
)

export default component.exports